Transaction = require 'models/transaction.coffee'
SaveTransaction = require 'interactions/save_transaction.coffee'
Currency = require 'models/currency.coffee'
TransactionsFilter = require('components/inside/pages/transactions/filter.coffee')

DEFAULT_FILTER =
  category:   ''
  type:       ''
  account_id: ''
  virtual_id: ''
  description_match: ''

store = {}
store.getters =
  find_transactions_categories: (state) -> (transactions, include_base_category = true) ->
    res = _.groupBy transactions, 'category'

    if include_base_category
      res2 = _.groupBy transactions, (tr) -> tr.baseCategory()
      res = _.merge(res, res2)

    res = _.map res, (transactions, category) -> { name: category, count: transactions.length }
    res = res.filter (category) -> !_.isEmpty(category.name)
    res = _.orderBy res, (category) -> -category.count

    return res

  transactions_categories_without_base_categories: (state, getters) ->
    getters.find_transactions_categories(state.user.transactions, _include_base_category = false)

  transactions_categories: (state, getters) ->
    getters.find_transactions_categories(state.user.transactions)

  not_hidden_transactions_categories: (state, getters) ->
    all_cats = getters.transactions_categories
    all_cats.filter((category) -> !getters.hidden_categories.includes(category.name))

  transactions_sum: (state, getters) ->
    (transactions) ->
      transactions ||= []
      transactions = transactions.filter (t) -> !t.isTransfer()
      total_in_usd = _.sumBy(transactions, (t) -> t.amountInUsd())
      Math.round Currency.convert(total_in_usd, 'usd', getters.default_currency)
  transactions_plan_sum: (state, getters) ->
    (transactions) ->
      transactions ||= []
      transactions = transactions.filter (t) -> t.isPlanned()
      transactions = transactions.filter (t) -> !t.isTransfer()
      total_in_usd = _.sumBy(transactions, (t) -> t.planAmountInUsd())
      Math.round Currency.convert(total_in_usd, 'usd', getters.default_currency)
  transactions_find: (state) ->
    (id) -> _.find state.user.transactions, { id: id }
  transactions_not_entered: (state) -> state.user.transactions.filter((tr) -> tr.isPlanned() && tr.isUnconfirmed())
  transactions_entered: (state)     -> state.user.transactions.filter((tr) -> tr.isConfirmed())

  transactions_past_not_entered: (state) ->
    res = TransactionsFilter(state.user.transactions, { type: 'past_not_entered' })
    _.orderBy(res, 'date', 'desc')
store.state =
  ui:
    transactions:
      mode: 'calendar'
      filter_default_value: DEFAULT_FILTER
      current:
        transaction: {}
        preview_ids: []
        last_used_account_id: null
      calendar:
        filter: _.clone(DEFAULT_FILTER) # clone value, so we don't change constant here
        current_month: undefined
        all_trs:  []
        filtered_trs: []
        event_title: undefined
        highlighted_transaction: null
      list:
        filter: _.clone(DEFAULT_FILTER) # clone value, so we don't change constant here
        dates:
          start: undefined
          end: undefined
        all_trs:  []
        filtered_trs: []

store.mutations =
  # Transactions
  'Load Transactions': (state, transactions) ->
    mapped_transactions = _.map transactions, (tr) -> new Transaction(tr)
    state.user.transactions = Object.freeze mapped_transactions
    return true

  'TRANSACTIONS/SELECT': (state, payload) ->
    state.ui.transactions.current.transaction = payload.transaction

  'TRANSACTIONS/SAVE': (state, payload) ->
    transaction = payload.transaction
    original = _.find state.user.transactions, { id: transaction.id }
    new_transactions = state.user.transactions.slice()
    if original
      _.merge original, transaction
    else
      new_transactions.push transaction
    state.user.transactions = Object.freeze(new_transactions)

  '💾 TRANSACTIONS/BULK_SAVE': (state, payload) ->
    trs = payload.transactions
    if trs.future_deleted_transactions_ids?.length
      state.user.transactions = Object.freeze(_.differenceWith state.user.transactions, trs.future_deleted_transactions_ids, (tr, id) -> tr.id == id)
    if trs.future_common_transactions?.length
      trs.future_common_transactions = _.map trs.future_common_transactions, (tr) -> new Transaction(tr, state.user)
      state.user.transactions = Object.freeze(_.unionBy trs.future_common_transactions, state.user.transactions, 'id')

  'TRANSACTIONS/DESTROY': (state, payload) ->
    transaction = payload.transaction
    new_transactions = state.user.transactions.slice()
    _.remove new_transactions, { id: transaction.id }
    state.user.transactions = Object.freeze(new_transactions)

  '💾 TRANSACTIONS/BULK_DESTROY': (state, transaction_ids) ->
    new_transactions = state.user.transactions.slice()
    _.remove new_transactions, (tr) -> transaction_ids.includes(tr.id)
    state.user.transactions = Object.freeze(new_transactions)

  'TRANSACTIONS/PREVIEW': (state, ids) ->
    state.ui.transactions.current.preview_ids = ids

  'TRANSACTIONS/CALENDAR/ALL': (state, transactions) ->
    state.ui.transactions.calendar.all_trs = transactions

  'TRANSACTIONS/CALENDAR/FILTERED': (state, transactions) ->
    state.ui.transactions.calendar.filtered_trs = transactions

  'TRANSACTIONS/LIST/ALL': (state, transactions) ->
    state.ui.transactions.list.all_trs = transactions

  'TRANSACTIONS/LIST/FILTERED': (state, transactions) ->
    state.ui.transactions.list.filtered_trs = transactions

  'TRANSACTIONS/CALENDAR/SET_FILTER': (state, filter) -> _.merge state.ui.transactions.calendar.filter, filter
  'TRANSACTIONS/LIST/SET_FILTER':     (state, filter) -> _.merge state.ui.transactions.list.filter, filter
  'TRANSACTIONS/CALENDAR/RESET_FILTER': (state) -> state.ui.transactions.calendar.filter = _.clone(DEFAULT_FILTER)
  'TRANSACTIONS/LIST/RESET_FILTER':     (state) -> state.ui.transactions.list.filter = _.clone(DEFAULT_FILTER)

  'CALENDAR/CHANGE_MONTH': (state, month) ->
    state.ui.transactions.calendar.current_month = month

  'LIST/CHANGE_DATES': (state, dates) ->
    dates = dates.split('--')
    state.ui.transactions.list.dates.start = dates[0]
    state.ui.transactions.list.dates.end   = dates[1]

store.actions =
  hideTransactionsPopovers: (context) ->
    $('.transaction').removeClass 'selected'
    unless _.isEmpty context.state.ui.transactions.current.transaction
      context.commit 'TRANSACTIONS/SELECT', transaction: {}
  ###*
   * Display transaction popover
   * @param  {Object} transaction
  ###
  selectTransaction: (context, transaction) ->
    $("#transaction-#{transaction.id}").addClass('selected') if !_.isEmpty transaction
    unless _.isEqual(context.state.ui.transactions.current.transaction, transaction)
      context.commit 'TRANSACTIONS/SELECT', { transaction: transaction, _find_by: "HM.store.getters.transactions_find(#{transaction.id})" }

  ###*
   * Make a new Transaction
   * @param  {attrs} subtype and date
  ###
  initTransaction: (context, attrs) ->
    current_filter = context.state.ui.transactions[context.state.ui.transactions.mode].filter
    filtered_account_id = current_filter?.account_id
    filtered_virtual_id = current_filter?.virtual_id
    if filtered_virtual_id
      virtual = context.getters.virtuals_find(filtered_virtual_id)
      attrs.virtual_id ||= virtual.id

    account =
      context.getters.accounts_find(filtered_account_id) ||
      context.getters.account_last_used ||
      context.getters.accounts_visible[0] ||
      context.getters.accounts[0]

    account1 = context.getters.accounts_visible[1] || context.getters.accounts[1]
    attrs.account_id ||= account.id
    attrs.currency ||= account.currency

    if attrs.subtype == 't'
      if attrs.transfer_type == 'a'
        attrs.transfer_from_id ||= account.id
        attrs.transfer_to_id   ||= (account1 || account).id
      else if attrs.transfer_type == 'v'
        attrs.transfer_from_id ||= -1
        attrs.transfer_to_id ||= context.getters.not_hidden_funds[0]?.id
        attrs.transfer_to_id ||= context.getters.not_hidden_goals[0]?.id # if there's no funds
        attrs.transfer_to_id ||= context.getters.virtuals[0].id # if there's no funds or goals

    new Transaction(attrs)

  ###*
   * Save local transaction
   * @param  {Object} transaction
  ###
  saveTransaction: (context, payload) ->
    interaction = new SaveTransaction(payload.transaction, payload.mode, payload.user, payload.change_future_trs)

    promise = interaction.run()
    promise.then (res) ->
      data = res.data
      context.commit 'TRANSACTIONS/SAVE', transaction: _.merge(interaction.transaction, data.transaction)
      context.commit '💾 ACCOUNTS_VIRTUALS/UPDATE', { accounts: data.accounts, virtuals: data.virtuals }
      if data.future_deleted_transactions_ids || data.future_common_transactions
        context.commit '💾 TRANSACTIONS/BULK_SAVE', transactions:
          future_deleted_transactions_ids : data.future_deleted_transactions_ids
          future_common_transactions      : data.future_common_transactions
    return promise

  destroyTransaction: (context, payload) ->
    tr = payload.transaction

    if payload.destroy_future_trs && tr.type == 'planned'
      trs_to_destroy = context.state.user.transactions.filter (t) => t.common_id == tr.common_id and t.date > tr.date
      ids_to_destroy = _.map trs_to_destroy, 'id'

    promise = HM_API.destroy_transaction { id: payload.transaction.id, future_trs_ids: ids_to_destroy }
    promise.then (res) ->
      if res.data.destroyed_future_trs_ids
        context.commit '💾 TRANSACTIONS/BULK_SAVE', transactions: { future_deleted_transactions_ids: res.data.destroyed_future_trs_ids }
      context.commit 'TRANSACTIONS/DESTROY', transaction: payload.transaction
      context.commit '💾 ACCOUNTS_VIRTUALS/UPDATE', { accounts: res.data.accounts, virtuals: res.data.virtuals }
    return promise

  calendarGoToMonth: (context, month) ->
    month = hm_date.startOfMonth_f month
    HM.router.push({name: 'calendar', query: { month: month }})

  downloadTransactions: (context, args) ->
    promise = HM_API.download_transactions args
    promise.then (res) ->
      file = new Blob([res.data], { type: 'text/csv' })
      if window.navigator.msSaveOrOpenBlob # IE10+
        window.navigator.msSaveOrOpenBlob file, 'HoneyMoney.csv'
      else
        a = document.createElement('a')
        url = URL.createObjectURL file
        a.href = url
        a.download = 'HoneyMoney.csv'
        document.body.appendChild(a)
        a.click()
        setTimeout (->
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
        ), 0


module.exports = store

